<template>
  <div class="projects-mac">
    <div id="acc"></div>
    <div id="blur">
      <header>
        <div class="header-main">
          <img class="banner" src="../assets/img/重点工程_banner.png" />
          <div class="title">重点案例</div>
        </div>
      </header>

      <main class="case-container">
        <div class="main2">
          <div class="case-left">
            <dl id="dl1">
              <dt
                id="one"
                class="activeTop"
                style="font-size: 24px; width: 200px;"
              >
                城市与建筑智能化
              </dt>
              <dd
                :class="currentIndex == index ? 'active2' : ''"
                v-for="(item, index) in list"
                :key="item.id"
                @click="change(index)"
              >
                <router-link :to="{ path: `${item.gopath}` }" class="color">{{
                  item.title
                }}</router-link>
              </dd>
            </dl>
            <!-- <dl id="dl2" style="padding-bottom:100px;">
              <dt id="two" style="font-size: 24px">智能交通</dt>
              <dd
                :class="currentIndex2 == index ? 'active3' : ''"
                v-for="(item, index) in list2"
                :key="item.id"
                @click="change2(index)"
              >
                <router-link :to="{ path: `${item.gopath}` }" class="color">{{
                  item.title
                }}</router-link>
              </dd>
            </dl> -->
          </div>
          <div class="case-right">
            <router-view ref="Mychild" v-cloak></router-view>
          </div>
        </div>
      </main>
    </div>
    <div>
      <Footer></Footer>
    </div>
  </div>
</template>
<script>
import Footer from "../components/footer.vue";
export default {
  components: { Footer },
  name: "test1",
  data() {
    return {
      currentIndex: 0, //表示当前选项卡,
      currentIndex2: -1,
      list: [
        {
          id: 0, //用来代表每一个对象
          title: "全部案例", //标题
          gopath: "/projects/project0"
        },
        {
          id: 1, //用来代表每一个对象
          title: "平安城市", //标题
          gopath: "/projects/project1"
        },
        {
          id: 2,
          title: "金融行业", //标题
          gopath: "/projects/project2"
        },
        {
          id: 3,
          title: "政府部门", //标题
          gopath: "/projects/project3"
        },
        {
          id: 4,
          title: "公安边防", //标题
          gopath: "/projects/project4"
        },
        {
          id: 5,
          title: "旅游景点", //标题
          gopath: "/projects/project5"
        },
        {
          id: 6,
          title: "文博系统", //标题
          gopath: "/projects/project6"
        },
        {
          id: 7,
          title: "医疗教育", //标题
          gopath: "/projects/project7"
        },
        {
          id: 8,
          title: "小区酒店", //标题
          gopath: "/projects/project8"
        },
        {
          id: 9,
          title: "企业单位", //标题
          gopath: "/projects/project9"
        }
      ],
      list2: [
        {
          id: 1, //用来代表每一个对象
          title: "全部案例", //标题
          gopath: "/projects/project13"
        },
        {
          id: 2, //用来代表每一个对象
          title: "道路监控", //标题
          gopath: "/projects/project10"
        },
        {
          id: 3,
          title: "运营车辆管理", //标题
          gopath: "/projects/project11"
        },
        {
          id: 4,
          title: "科技治超", //标题
          gopath: "/projects/project12"
        }
      ],
      debounceTimer: null,
      currentScrollPosition: 0
    };
  },
  created() {
    window.toggle = this.toggle;
  },
  mounted() {
    // 绑定滚动事件监听器
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("keyup", this.closeDialog);
  },
  beforeDestroy() {
    // 组件销毁时移除滚动事件监听器
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("keyup", this.closeDialog);
  },
  methods: {
    closeDialog(event) {
      // console.log(event.key);
      if (event.key == "Enter") {
        console.log("dianji");
        this.$refs.Mychild.closeDialog();
      }
    },
    handleScroll() {
      this.currentScrollPosition = window.scrollY;
      console.log("获取初始滚动位置1", this.currentScrollPosition);
    },
    // handleScroll() {
    //   this.currentScrollPosition = window.scrollY;
    //   console.log("获取初始滚动位置", this.currentScrollPosition);
    //   clearTimeout(this.debounceTimer);
    //   this.debounceTimer = setTimeout(() => {
    //     // this.selectBySub();
    //     const windowHeight = window.innerHeight;
    //     const documentHeight = document.documentElement.scrollHeight;
    //     const scrollTop =
    //       window.pageYOffset ||
    //       document.documentElement.scrollTop ||
    //       document.body.scrollTop;
    //     if (scrollTop + windowHeight >= documentHeight) {
    //       this.$refs.Mychild.loadMoreData();
    //     }
    //   }, 300);
    //   // 在组件挂载后获取初始滚动位置;
    //   this.currentScrollPosition = window.scrollY;
    //   console.log("获取初始滚动位置", this.currentScrollPosition);
    // },
    toggle() {
      var blur = document.getElementById("blur");
      blur.classList.toggle("active");
      var popular = document.getElementById("popular");
      popular.classList.toggle("active");
      var acc = document.getElementById("acc");
      acc.classList.toggle("active");
    },

    scrollToPosition(position) {
      // 在点击选项卡时设置滚动位置为之前的滚动位置
      // console.log("滚动到原来的位置", this.currentScrollPosition);
      window.scrollTo({
        // top: position
        top: this.currentScrollPosition
        // behavior: "smooth" // 可以使用 'auto' 或 'smooth' 控制滚动的动画效果
      });
    },
    change(index) {
      this.scrollToPosition();

      console.log("菜单index", index);
      var c1 = document.getElementById("one");
      if (c1 != null) {
        c1.className = "activeTop";
      }
      var c2 = document.getElementById("two");
      if (c2 != null) {
        c2.className = "";
      }

      var c3 = document.querySelector(".active3");
      if (c3 != null) {
        c3.className = "";
      }
      // var c2 = document.querySelector(".active2")
      // if(c2 != null ){
      //   c2.className=""
      // }
      // document.querySelector(".active2").removeAttribute("active2")
      //用来实现切换功能
      //实现选项卡 切换操作 - 本质就是操作类名
      // 通过currentIndex操作
      this.currentIndex = index;
      document.getElementById("dl1").childNodes[index + 2].className =
        "active2";
      // this.$router.push({ path: `/projects/project${index + 1}` }, () => {});
      this.$router.push({ path: `/projects/project${index}` }, () => {});
    },
    change2(index) {
      var c3 = document.getElementById("two");
      // document.getElementById("one").className="abc"
      if (c3 != null) {
        c3.className = "active2Top";
      }
      var c4 = document.getElementById("one");
      if (c4 != null) {
        c4.className = "";
      }

      var c5 = document.querySelector(".active2");
      if (c5 != null) {
        c5.className = "";
      }

      // var c4 = document.querySelector(".active")
      // if(c4 != null){
      //   c4.className=""
      // }
      //用来实现切换功能
      //实现选项卡 切换操作 - 本质就是操作类名
      // 通过currentIndex操作
      this.currentIndex2 = index;
      document.getElementById("dl2").childNodes[index + 2].className =
        "active3";
      this.$router.push({ path: `/projects/project${index + 10}` }, () => {});
    }
  }
};
</script>
<style scoped>
@import "../assets/css/casePresentation.css";

.case-left dl .activeTop {
  color: #140047;
  white-space: nowrap;
  /* font-size: 18px; */
  font-size: 24px;
  line-height: 25px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  position: relative;
  z-index: 10;
}
.case-left dl .active2Top {
  color: #140047;
  white-space: nowrap;
  font-size: 24px;
  line-height: 27px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.case-left dl .active2 a {
  color: #140047 !important;
  opacity: 1;
}
.case-left dl .active3 a {
  color: #140047 !important;
  opacity: 1;
}

/* .active2 a{
      color:#140047
    } */
body::-webkit-scrollbar {
  width: 0;
}

header {
  height: 500px;
}
header h1 {
  margin-top: 163px;
  text-align: center;
  font-size: 48px;
  color: #ffffff;
  line-height: 65px;
  letter-spacing: 12px;
}
body {
  position: relative;
}

main {
  padding-top: 80.0064px;
}
.main2 {
  position: relative;
  /* height: 934px; */
  /* overflow-y: scroll; */
}
.main2::-webkit-scrollbar {
  display: none;
}

.case-left {
  width: 200px;
  margin-right: 20px;
}
.case-left dl {
  width: 160px;
  font-weight: 500;
}
.case-left dl dd a {
  color: #000000;
  opacity: 0.22;
}
.case-left dl a {
  color: rgba(0, 0, 0, 0.22);
  transition: color 0.3s;
}
.case-left dl dt {
  color: rgba(0, 0, 0, 0.22);
  font-size: 16px;
  line-height: 23px;
}
.case-left dl dd {
  margin-top: 14px;
  /* font-size: 20px;
  line-height: 21px; */
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 28px;
}
.case-left dl:nth-child(2) {
  margin-top: 40px;
}

.center-right1 {
  flex: 1;
}
.center-right {
  flex: 1;
}
.center-right ul {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(4, 25%);
  justify-items: end;
}
.center-right ul li {
  margin-bottom: 32px;
  width: 90%;
  box-shadow: 0rem 0.9984px 10.0032px 0rem rgba(206, 206, 206, 0.5);
  transition: transform 0.3s;
}
.center-right ul li:nth-child(4n) {
  margin-right: 0;
}
.center-right ul li .img {
  background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/17fb0128623b4b53b944d5d542327a1b_mergeImage.png);
  background-size: 100% 100%;
  height: 276px;
}
.center-right ul li:nth-child(2) .img {
  background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/e855c6e3f1c24e0596a0d39dd69ae4be_mergeImage.png);
}
.center-right ul li:nth-child(3) .img {
  background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/afb7a1485dc94b8080da835a16d85d97_mergeImage.png);
}
.center-right ul li:nth-child(4) .img {
  background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/0a2cdb7fef1741e48c95458b4ef5a2ac_mergeImage.png);
}
.center-right ul li:nth-child(5) .img {
  background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/a50ec9e6940246fbabd52c5a763aec6c_mergeImage.png);
}
.center-right ul li:nth-child(6) .img {
  background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/861c3076a3e24c0ab3f71862e73507f6_mergeImage.png);
}
.center-right ul li .text {
  position: relative;
  padding-left: 20px;
  padding-top: 20px;
  padding-right: 20px;
  padding-bottom: 108px;
}
.center-right ul li .text p {
  padding-bottom: 16px;
  font-size: 18px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.58);
  line-height: 36px;
}
.center-right ul li .text button {
  position: absolute;
  top: 108px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 52px;
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0rem 0.9984px 10.0032px 0rem rgba(206, 206, 206, 0.5);
  border-radius: 0.0208rem;
  border: 0.0052rem solid #140047;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #140047;
  line-height: 24px;
  text-shadow: 0rem 0.9984px 10.0032px rgba(206, 206, 206, 0.5);
}
.center-right ul li .text button img {
  margin-left: 40px;
  width: 18px;
  height: 10px;
}
.center-right ul li:hover {
  transform: translate(0, -10.0032px);
}

.header-main {
  height: 500px;
  position: relative;
}
.title {
  top: 243px;
  font-size: 48px;
  font-family: AlibabaPuHuiTiB;
  color: #ffffff;
  line-height: 65px;
  letter-spacing: 12px;
}

#dl1 {
  position: sticky;
  top: 100px;
}

[v-cloak] {
  display: none;
}

.case-right {
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/projects.vue